import Main from '../pages/Project/Main'
import Add from '../pages/Project/Add'
import Commit from '../pages/Project/Commit'
import Pay from '../pages/Project/Pay'
import Detail from '../pages/Project/Detail'
import ServiceInfo from '../pages/Project/ServiceInfo'
import QueryResult from '../pages/Project/QueryResult'
import GetResult from '../pages/Project/GetResult'
import ServicePayInfo from '../pages/Project/ServicePayInfo'
import ServicePay from '../pages/Project/ServicePay'
import QuerySettle from '../pages/Project/QuerySettle'
import PrePend from '../pages/Project/PrePend'
import Evaluate from '../pages/Project/Evaluate'
import ServiceRecord from '../pages/Project/ServiceRecord'
import Check from '../pages/Project/Check'
import Step1 from '../pages/Project/Step1'
import Step2 from '../pages/Project/Step2'
import Step3 from '../pages/Project/Step3'
import Step4 from '../pages/Project/Step4'
import ProjectRecord from '../pages/Project/ProjectRecord'
import Tips from '../pages/Project/Tips'
import ServiceResults from '../pages/Project/ServiceResults'
import Services from '../pages/Project/Services'
import Batch from '../pages/Project/Batch'
import BStep1 from '../pages/Project/BStep1'
import BStep2 from '../pages/Project/BStep2'
import BStep3 from '../pages/Project/BStep3'

export default [
    {
        path: '',
        component: Main
    },
    {
        path: 'main',
        component: Main
    },
    {
        path: 'services',
        component: Services
    },
    {
        path: 'add',
        component: Add
    },
    {
        path: 'commit',
        component: Commit
    },
    {
        path: 'pay',
        component: Pay
    },
    {
        path: 'detail',
        component: Detail
    },
    {
        path: 'prepend',
        component: PrePend
    },
    {
        path: 'serviceinfo',
        component: ServiceInfo
    },
    {
        path: 'queryresult',
        component: QueryResult
    },
    {
        path: 'getresult',
        component: GetResult
    },
    {
        path: 'servicepayinfo',
        component: ServicePayInfo
    },
    {
        path: 'servicepay',
        component: ServicePay
    },
    {
        path: 'querysettle',
        component: QuerySettle
    },
    {
        path: 'evaluate',
        component: Evaluate
    },
    {
        path: 'servicerecord',
        component: ServiceRecord
    },
    {
        path: 'projectrecord',
        component: ProjectRecord
    },
    {
        path: 'servicecommited',
        component: Tips
    },
    {
        path: 'serviceresults',
        component: ServiceResults
    },
    {
        path: 'batch',
        component: Batch,
        children: [
            {
                path: '',
                redirect: 'step1'
            },
            {
                path: 'step1',
                component: BStep1
            },
            {
                path: 'step2',
                component: BStep2
            },
            {
                path: 'step3',
                component: BStep3
            }
        ]
    },
    {
        path: 'check',
        component: Check,
        children: [
            {
                path: '',
                redirect: 'step1'
            },
            {
                path: 'step1',
                component: Step1
            },
            {
                path: 'step2',
                component: Step2
            },
            {
                path: 'step3',
                component: Step3
            },
            {
                path: 'step4',
                component: Step4
            }
        ]
    }
]
